var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.96875C18.75 13.4375 10.6414 17.8641 10.2961 18.0469C10.2051 18.0958 10.1033 18.1215 10 18.1215C9.89665 18.1215 9.79492 18.0958 9.70391 18.0469C9.35859 17.8641 1.25 13.4375 1.25 7.96875C1.25145 6.68455 1.76223 5.45337 2.6703 4.5453C3.57837 3.63723 4.80955 3.12645 6.09375 3.125C7.70703 3.125 9.11953 3.81875 10 4.99141C10.8805 3.81875 12.293 3.125 13.9062 3.125C15.1904 3.12645 16.4216 3.63723 17.3297 4.5453C18.2378 5.45337 18.7486 6.68455 18.75 7.96875Z",
    fill: "#D52035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullHeart);
export default __webpack_public_path__ + "static/media/full-heart.a1a7beed869c705d660ecb1ed4cdd6bb.svg";
export { ForwardRef as ReactComponent };